import { render, staticRenderFns } from "./ModalReset.vue?vue&type=template&id=199f71a8&scoped=true"
import script from "./ModalReset.vue?vue&type=script&lang=js"
export * from "./ModalReset.vue?vue&type=script&lang=js"
import style0 from "./ModalReset.vue?vue&type=style&index=0&id=199f71a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199f71a8",
  null
  
)

export default component.exports